import React from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../../_metronic/helpers'
import Swal from 'sweetalert2'
import { deleteLaunch } from '../../../../../services/http/urbit-gis/routes'

type Props = {
  id: number
  handleRefetch: () => void
}

export const Buttons: React.FC<Props> = ({id, handleRefetch}) => {

  function confirmDelete(id) {
    Swal.fire({
      title: 'Deseja desativar?',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Excluir',
      showCloseButton: true,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const result = await deleteLaunch(id)
        if (result) {
          Swal.fire('Sucesso!', 'Empresa desativada com sucesso.', 'success')
          handleRefetch()
        }
      }
    })
  }

  return (
    <>
      <div className='d-flex justify-content-end flex-shrink-0'>
        <Link
          to={`/backoffice/empreendimentos/edit/${id}`}
          className='btn btn-icon btn-light-success me-2'
        >
          <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
        </Link>
        <button
          onClick={() => {
            confirmDelete(id)
          }}
          type='button'
          className='btn btn-icon me-2 btn-light-danger btn-sm'
        >
          <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
        </button>
      </div>
    </>
  )
}
